module.exports = __webpack_public_path__ + "static/media/ecuUpgrade.b5952300.jpg";